import List from '../../src/legacy/List';
export default List;
